"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpawnSimulatedPersonsRandomRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
/**
 * Random spawn within a location scope. Provide exactly one of:
 * - venuePublicIds
 * - bounding box (NE/SW)
 * - center point + radiusMeters
 */
class SpawnSimulatedPersonsRandomRequestDto {}
exports.SpawnSimulatedPersonsRandomRequestDto = SpawnSimulatedPersonsRandomRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  example: 5,
  description: 'How many idle active personas to spawn.'
}), __metadata("design:type", Number)], SpawnSimulatedPersonsRandomRequestDto.prototype, "count", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  type: [String],
  description: 'Explicit venue public ids to distribute across.'
}), __metadata("design:type", Array)], SpawnSimulatedPersonsRandomRequestDto.prototype, "venuePublicIds", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Number)], SpawnSimulatedPersonsRandomRequestDto.prototype, "northeastLatitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Number)], SpawnSimulatedPersonsRandomRequestDto.prototype, "northeastLongitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Number)], SpawnSimulatedPersonsRandomRequestDto.prototype, "southwestLatitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Number)], SpawnSimulatedPersonsRandomRequestDto.prototype, "southwestLongitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Center latitude for radius search.'
}), __metadata("design:type", Number)], SpawnSimulatedPersonsRandomRequestDto.prototype, "latitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Center longitude for radius search.'
}), __metadata("design:type", Number)], SpawnSimulatedPersonsRandomRequestDto.prototype, "longitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  example: 2000,
  description: 'Search radius in meters around latitude/longitude.'
}), __metadata("design:type", Number)], SpawnSimulatedPersonsRandomRequestDto.prototype, "radiusMeters", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  example: 5,
  description: 'Cap how many distinct venues receive spawns. Defaults to count.'
}), __metadata("design:type", Number)], SpawnSimulatedPersonsRandomRequestDto.prototype, "maxVenues", void 0);
//# sourceMappingURL=SpawnSimulatedPersonsRandomRequest.dto.js.map